<div class="-mb-3">
  <div class="flex items-baseline justify-between gap-2">
    <rk-page-title
      [title]="'MEDIA.CONTEXT_MENU.ADD_PROGRAM_PLAYLIST' | translate"
    ></rk-page-title>
    <div class="text-gray-darkest">{{ $step() }}/{{ totalSteps }}</div>
  </div>
</div>
<form [formGroup]="addPlaylistForm" class="flex flex-1">
  <mat-stepper linear class="flex-1 -mx-5 -mb-5 no-header full-height" #stepper>
    <mat-step class="flex flex-col flex-1">
      <div class="step">
        <div
          class="subtitle"
          [innerHTML]="'SCHEDULE.PROGRAMS.ADD_PLAYLIST_STEP_1' | translate"
        ></div>
        @if ((playlistsUnfiltered$ | async)?.length) {
          <rk-search-bar
            (inputted)="onChangeSearch($event)"
            [customPlaceholder]="'PLAYLIST.SEARCH_BAR.PLACEHOLDER' | translate"
          ></rk-search-bar>
          @if ((playlists$ | async)?.length) {
            <div class="playlists-title my-2 px-6 -mx-5 h-9 flex items-center" translate>
              MEDIA.PLAYLISTS.TITLE
            </div>
            <div class="playlist-list flex flex-1 bg-white -mx-5 px-3">
              <cdk-virtual-scroll-viewport
                class="flex-1 w-full"
                itemSize="44"
                minBufferPx="800"
                maxBufferPx="1000"
              >
                <div
                  class="playlist-line relative flex items-center gap-2.5 text-black flex-1 py-3 px-2"
                  *cdkVirtualFor="
                    let playlist of playlists$ | async;
                    let i = index;
                    templateCacheSize: 60
                  "
                  (click)="selectPlaylist(playlist)"
                >
                  <rk-playlist-icon class="h-5" [playlist]="playlist"></rk-playlist-icon>
                  <div class="truncate text-base">{{ playlist.name }}</div>
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          } @else {
            <div class="search-empty">
              <img src="/assets/search-empty.svg" alt="" />
              <div>
                {{
                  'MEDIA.TABLE.SEARCH_EMPTY'
                    | translate: { search: searchSubject.getValue() }
                }}
              </div>
            </div>
          }
        } @else {
          Aucune playlist
        }
      </div>
    </mat-step>
    <mat-step>
      <div class="step">
        <div
          class="subtitle"
          [innerHTML]="
            'SCHEDULE.PROGRAMS.ADD_PLAYLIST_STEP_2'
              | translate: { name: addPlaylistForm.get('selectedPlaylist').value?.name }
          "
        ></div>
        <rk-form-field [label]="'MODAL.ADD_PLAYLIST.TYPE' | translate">
          <mat-button-toggle-group formControlName="sorting" class="mt-2.5 mb-7">
            <mat-button-toggle value="Sequential">
              <mat-icon fontSet="fa" fontIcon="fa-list"></mat-icon>
              {{ 'MODAL.ADD_PLAYLIST.SEQUENTIAL' | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="Random">
              <mat-icon fontSet="fa" fontIcon="fa-random"></mat-icon>
              {{ 'MODAL.ADD_PLAYLIST.RANDOM' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </rk-form-field>

        <rk-form-field
          [label]="'MODAL.ADD_PLAYLIST.TRACKS_NUMBER' | translate"
          hintLocation="between"
          [hintLabel]="'MODAL.ADD_PLAYLIST.HINT_TRACKS_NUMBER' | translate"
        >
          <input
            rkInput
            type="number"
            inputType="num"
            formControlName="tracksNumber"
            pKeyFilter="num"
            min="1"
            class="!max-w-full"
          />
        </rk-form-field>

        <rk-footer-actions
          class="!pb-5"
          [cancelText]="'GLOBAL.PREV' | translate"
          [submitText]="'GLOBAL.ADD' | translate"
          [forceLeft]="true"
          (cancelled)="prevStep()"
          (submitted)="submit()"
        ></rk-footer-actions>
      </div>
    </mat-step>
  </mat-stepper>
</form>
